import { useProfile } from 'providers/profile.provider';
import { BIZCONTA_APP } from 'constants/constants';

import QrCode from 'assets/img/qrcode-tela-final.png';
import GooglePlay from 'assets/svg/google-play2.svg';
import PlayStore from 'assets/svg/play-store2.svg';


import './app-stores.styles.scss';

export type AppStoresProps = {
    text?: string;
};

const AppStores = ({ text }: AppStoresProps) => {
    const { loanApplicationUtmMedium } = useProfile();

    if (loanApplicationUtmMedium === BIZCONTA_APP) {
        return null;
    }

    return (
        <div className="app-stores">
            {
                text && (
                    <small className="app-stores__text hidden-sm">
                        {text}
                    </small>
                )
            }
            <div className="app-stores__row">
                <div className="app-stores__qrcode hidden-sm">
                    <img src={QrCode} />
                </div>
                <div className="app-stores__btn-group">
                    <a className="app-stores__button" href="https://biz-conta.onelink.me/7nkz?pid=site&c=tela-final-bizon&af_adset=lojas" target="_blank" >
                        <img src={GooglePlay} />
                    </a>
                    <a className="app-stores__button" href="https://biz-conta.onelink.me/7nkz?pid=site&c=tela-final-bizon&af_adset=lojas" target="_blank" >
                        <img src={PlayStore} />
                    </a>
                </div>
            </div>
        </div>
    );
}

export default AppStores;
